"use strict";

var _slicedToArray = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/helpers/slicedToArray");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("source-map-support/register");

var _types = _interopRequireDefault(require("./types"));

var _error = require("../../error");

var _lodash = require("lodash");

var findRec = function findRec(node, fn) {
  var found = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  if ((0, _lodash.isObject)(node)) {
    Object.entries(node).forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          type = _ref2[0],
          value = _ref2[1];

      if (fn({
        type: type,
        value: value
      })) {
        found.push({
          type: type,
          value: value
        });
      }

      if (Array.isArray(value)) {
        value.map(function (child) {
          return findRec(child, fn, found);
        });
      } else if ((0, _lodash.isObject)(value)) {
        findRec(value, fn, found);
      }
    });
  }

  return found;
};

function metadataWalker(data) {
  return {
    data: data,
    type: _types.default,
    find: function find(fn) {
      return findRec({
        root: data
      }, fn);
    },
    findOne: function findOne(fn) {
      var found = this.find(fn);

      if (found.length === 0) {
        throw new _error.SearchError('No data found matching criteria');
      }

      var value = found[0].value;
      return Array.isArray(value) ? value[0] : value;
    }
  };
}

var _default = metadataWalker;
exports.default = _default;